import * as React from "react";

import { cn } from "@/lib/shadcn-utils";
import { useField } from "remix-validated-form";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: string,
  label: string,
  placeholder?: string,
  helperText?: string
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    const { error, getInputProps } = useField(props.name);

    return (
      <div className={`${className ?? ""} flex text-sm flex-col gap-1`}>
        <label className="text-gray-600 font-semibold" htmlFor={props.name}>{props.label}</label>
        <textarea
          className={cn(
            "flex min-h-[80px] w-full transition rounded-md border border-gray-200 bg-white px-3 py-2 text-sm ring-offset-white placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-800 dark:bg-gray-950 dark:ring-offset-gray-950 dark:placeholder:text-gray-400 dark:focus-visible:ring-gray-300",
            className
          )}
          ref={ref}
          {...getInputProps({ id: props.name, placeholder: props.placeholder })}
          {...props}
        />
        {props.helperText &&
          <p className={`text-gray-500 text-xs`}>{props.helperText}</p>
        }
        {error &&
          <span className="text-red-500">{error}</span>
        }
      </div>
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
